<template>
  <v-menu bottom left offset-y transition="v-scale-transition">
    <template v-slot:activator="{ on }">
      <v-btn text small v-on="on" :aria-label="$t('app.language')" :class="buttonClass">
        <v-icon small left>language</v-icon>
        {{ currentLocaleName }}
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="option in availableLocales"
        :key="option.code"
        :input-value="option.code === locale"
        @click="setLocale(option.code)"
      >
        <v-list-item-title>{{ option.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'locale-switcher',
  props: {
    buttonClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['locale', 'availableLocales']),
    currentLocaleName() {
      const found = this.availableLocales.find((option) => option.code === this.locale);
      return found ? found.name : this.locale;
    },
  },
  methods: {
    ...mapActions(['setLocale']),
  },
};
</script>
